// extracted by mini-css-extract-plugin
export default {"gradeInputElem":"gradeInput_gradeInputElem__OcHOH","gradeBtn":"gradeInput_gradeBtn__NcVpC"};